module.exports = __webpack_public_path__ + "img/airplane-white.7ca6c94a.svg";